<nav class="ca-header">
  <div class="header-wrapper">
    <div class="flex-shrink"></div>
    <a class="maxis-logo">
      <img [src]="'assets/images/maxis-logo.png'" alt="Maxis Logo">
    </a>
  </div>
</nav>